// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storageComponent {
    height: 30px;
    margin: auto;
    text-align: center;
    width: -webkit-fill-available;
}

.MuiSlider-root {
    height: 10px !important;
}

.storage-background {
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.25) 0 1px 5px 0;
}

.storageComponent:hover {
    cursor: default;
}

#storageComponent h3 {
    font-size: 12px;
    color: #5E5E5E;
    margin: 0;
}

.percentage-circle {
    width: 30%;
    height: 75%;
}

@media screen and (max-width: 600px) {
    .percentage-circle {
        width: 75px;
        height: 75px;
    }

    .storageComponent {
        height: 100px;
    }

    h3 {
        margin: revert;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/StorageComponent.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".storageComponent {\n    height: 30px;\n    margin: auto;\n    text-align: center;\n    width: -webkit-fill-available;\n}\n\n.MuiSlider-root {\n    height: 10px !important;\n}\n\n.storage-background {\n    margin: 10px;\n    padding: 10px;\n    border-radius: 10px;\n    box-shadow: rgba(0, 0, 0, 0.25) 0 1px 5px 0;\n}\n\n.storageComponent:hover {\n    cursor: default;\n}\n\n#storageComponent h3 {\n    font-size: 12px;\n    color: #5E5E5E;\n    margin: 0;\n}\n\n.percentage-circle {\n    width: 30%;\n    height: 75%;\n}\n\n@media screen and (max-width: 600px) {\n    .percentage-circle {\n        width: 75px;\n        height: 75px;\n    }\n\n    .storageComponent {\n        height: 100px;\n    }\n\n    h3 {\n        margin: revert;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
